import { type JSX, useCallback, useState } from "react";
import { useQuery } from "urql";
import Loader from "../../shared/components/Loader";
import ShowError from "../components/ShowError";
import { sentQuery } from "./query";
import SentMessage from "./SentMessage";

function Sent(): JSX.Element {
    const [open, setOpen] = useState<string>("");

    const [result] = useQuery({
        query: sentQuery,
    });
    const toggleOpen = useCallback((id: string) => {
        setOpen((open) => (open === id ? "" : id));
    }, []);

    if (result.fetching) {
        return <Loader />;
    }
    if (result.error) {
        return <ShowError />;
    }

    return (
        <section>
            {result.data.learningCoachMessageList.map((message) => (
                <SentMessage key={message.id} message={message} open={open === message.id} toggleOpen={toggleOpen} />
            ))}
        </section>
    );
}

export default Sent;
